import type { FaireProductEntity } from "../../entity_types/product";

export const p_depfnyqvzp: FaireProductEntity = {
  token: "p_depfnyqvzp",
  type: "product",
  name: "Cozy Cabin - Soy Wax Mason Jar Candle",
  brandName: "Antique Candle Co.\u00ae",
  imageUrl:
    "https://cdn.faire.com/fastly/8276ea4fa64d2a68dfe51ba011b0f8b3a13fe1fbf7a7b65dd329695d93c2dce9.jpeg",
  priceDollars: 19,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8b9ab5927ddf5425df26d14cd726b198fb2b55d893c57f3c8a44a31c1f0c7186.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
